export default __webpack_public_path__ + "static/media/partner_logo_kahoot.36cc0e75.svg";